import {
  Icon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';

import { setIsGiftCardIncompatibleProductsAllModalOpen } from '../../store/slices/billing';
import { BillingGiftCardError } from '../../ui/react/src';

export default function GiftcardIncompatibleProductsModalAll() {
  const isOpen = useAppSelector(
    (state) => state.billing.isGiftCartIncompatibleProductsAllModalOpen
  );
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(setIsGiftCardIncompatibleProductsAllModalOpen(false));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalHeader onClose={onClose} className="co-border-b-0" />

      <ModalBody className="co-flex co-flex-col co-gap-32px co-items-center">
        <BillingGiftCardError />

        <div className="co-flex co-flex-col co-gap-16px">
          <Text
            variant="subtitle1"
            element="p"
            weight={600}
            color="neutral-900"
            className="co-leading-24px co-text-center"
          >
            Lo sentimos, no se pueden comprar los productos con esta Gift Card
          </Text>
          <Text
            variant="body1"
            element="p"
            color="neutral-700"
            className="co-text-center co-text-[16px]"
          >
            Por favor, utiliza otro medio de pago para continuar con tu compra.
          </Text>
        </div>

        <div className="co-flex co-gap-8px co-border-1 co-border-pds-information-500 co-rounded-8px co-p-8px">
          <div className="co-w-20px co-h-20px">
            <Icon name="info-circle" fill="info-500" width={20} height={20} />
          </div>
          <Text
            variant="body1"
            element="p"
            color="neutral-900"
            weight={600}
            className="co-leading-[20px]"
          >
            Puedes usar tu Gift Card en otra compra ingresando el mismo número
            de tarjeta y clave.
          </Text>
        </div>
      </ModalBody>

      <ModalFooter
        className="co-border-t-0"
        primaryButton={{
          label: 'Continuar con otro medio de pago',
          onClick: onClose
        }}
      ></ModalFooter>
    </Modal>
  );
}
